const organizations = {
    title: 'سازمان‌ها',
    description: 'سازمان‌هایی را که عضو آن‌ها هستید ایجاد و مدیریت کنید.',
    create: 'ایجاد سازمان',
    create_title: 'ایجاد سازمان جدید',
    name: 'نام سازمان',
    avatar: 'تصویر سازمان',
    avatar_removed: 'تصویر سازمان حذف شد.',
    description_label: 'توضیحات',
    empty: 'هنوز عضو هیچ سازمانی نیستید.',
    pending_invitations: 'دعوت‌های در انتظار',
    accept: 'پذیرش',
    decline: 'رد کردن',
    owner: 'مالک',
    tabs: {
        overview: 'نمای کلی',
        members: 'اعضا',
        invitations: 'دعوت‌ها',
        roles: 'نقش‌های مدیریتی',
        branding: 'هویت بصری',
        security: 'امنیت',
        jit: 'تأمین آنی',
        applications: 'منابع مشترک',
        activity: 'فعالیت',
        deletion: 'حذف',
    },
    members: {
        title: 'اعضا',
        empty: 'عضوی یافت نشد.',
        remove: 'حذف',
        removed: 'عضو حذف شد.',
        business_roles: 'نقش‌های تجاری',
        no_business_roles: 'نقش تجاری در دسترس نیست. از مدیر مستأجر بخواهید نقش‌هایی را با این سازمان به اشتراک بگذارد.',
    },
    invitations: {
        title: 'دعوت‌ها',
        invite: 'دعوت عضو',
        email: 'نشانی ایمیل',
        empty: 'دعوتی یافت نشد.',
        resend: 'ارسال مجدد',
        resent: 'دعوت دوباره ارسال شد.',
        revoke: 'لغو دعوت',
        revoked: 'دعوت لغو شد.',
        status: {
            Pending: 'در انتظار',
            Accepted: 'پذیرفته‌شده',
            Expired: 'منقضی‌شده',
            Revoked: 'لغوشده',
            Declined: 'ردشده',
        },
    },
    roles: {
        title: 'نقش‌های مدیریتی',
        create: 'ایجاد نقش',
        permissions: 'مجوزها',
        empty: 'نقش مدیریتی یافت نشد.',
        select_member: 'انتخاب عضو',
        select_role: 'انتخاب نقش',
        assign: 'تخصیص نقش',
        assigned: 'نقش تخصیص یافت.',
        unassign: 'حذف نقش',
        unassigned: 'نقش حذف شد.',
        permission_count: 'تعداد مجوزها: {{count}}',
        built_in: {
            owner: 'مالک',
            owner_description: 'مالکان اختیار انحصاری مدیریت مالکیت و حذف سازمان را دارند.',
            administrator: 'مدیر',
            administrator_description: 'سازمان را به‌جز عملیات مختص مالکان مدیریت می‌کند.',
        },
        permission_labels: {
            update_profile: 'به‌روزرسانی نمایه',
            manage_branding: 'مدیریت هویت بصری',
            view_members: 'مشاهده اعضا',
            manage_members: 'مدیریت اعضا',
            manage_invitations: 'مدیریت دعوت‌ها',
            assign_business_roles: 'تخصیص نقش‌های تجاری',
            manage_management_roles: 'مدیریت نقش‌های مدیریتی',
            assign_management_roles: 'تخصیص نقش‌های مدیریتی',
            manage_security: 'مدیریت امنیت',
            manage_jit: 'مدیریت تأمین آنی',
            manage_applications: 'مدیریت برنامه‌ها',
            view_activity: 'مشاهده فعالیت',
        },
    },
    branding: {
        title: 'هویت بصری سازمان',
        primary_color: 'رنگ اصلی',
        custom_css: 'CSS سفارشی',
        preview: 'پیش‌نمایش',
        light: 'روشن',
        dark: 'تیره',
    },
    security: {
        title: 'امنیت سازمان',
        require_mfa: 'الزام احراز هویت چندعاملی برای اعضا',
    },
    jit: {
        title: 'دامنه‌های ایمیل تأمین آنی',
        domain: 'دامنه ایمیل',
        add: 'افزودن دامنه',
        verify: 'بررسی DNS',
        dns_instruction: 'رکورد TXT با نام {{record}} و مقدار {{value}} ایجاد کنید.',
        verified: 'تأییدشده',
    },
    applications: {
        title: 'منابع مشترک',
        empty: 'منبعی برای این سازمان در دسترس نیست.',
        sso: 'اتصال‌های ورود یکپارچه سازمانی',
        m2m: 'برنامه‌های ماشین به ماشین',
    },
    activity: {
        title: 'فعالیت سازمان',
        empty: 'هنوز فعالیتی وجود ندارد.',
        events: {
            create: 'سازمان ایجاد شد',
            delete: 'سازمان حذف شد',
            profile: 'نمایه سازمان به‌روزرسانی شد',
            branding: 'هویت بصری سازمان به‌روزرسانی شد',
            security: 'امنیت سازمان به‌روزرسانی شد',
            member_add: 'عضو اضافه شد',
            member_remove: 'عضو حذف شد',
            owner: 'مالکیت سازمان به‌روزرسانی شد',
            role_create: 'نقش مدیریتی ایجاد شد',
            role_update: 'نقش مدیریتی به‌روزرسانی شد',
            role_delete: 'نقش مدیریتی حذف شد',
            role_assign: 'نقش مدیریتی تخصیص یافت',
            role_unassign: 'نقش مدیریتی عضو حذف شد',
            business_role: 'نقش‌های تجاری به‌روزرسانی شدند',
            invitation_create: 'دعوت ارسال شد',
            invitation_accept: 'دعوت پذیرفته شد',
            invitation_decline: 'دعوت رد شد',
            invitation_revoke: 'دعوت لغو شد',
            jit: 'تأمین آنی به‌روزرسانی شد',
            domain: 'تأیید دامنه ایمیل',
            application: 'اتصال‌های برنامه‌ها به‌روزرسانی شدند',
            unknown: 'فعالیت سازمان',
        },
    },
    save: 'ذخیره تغییرات',
    cancel: 'انصراف',
    delete: 'حذف سازمان',
    delete_confirmation: 'این کار سازمان و عضویت‌های آن را برای همیشه حذف می‌کند. برای تأیید «{{name}}» را وارد کنید.',
    deleted: 'سازمان حذف شد.',
    load_failed: 'داده‌های سازمان بارگیری نشد. دوباره تلاش کنید.',
    permission_denied: 'اجازه مشاهده این بخش را ندارید.',
};
export default organizations;
